import { useCallback, useEffect, useState } from "react";
import { apiFetch, formatApiErrorDetail } from "./auth";
import { conversion } from "./analytics";

const DRAFT = "vl-elig-draft";
export const saveEligDraft = (d) => localStorage.setItem(DRAFT, JSON.stringify({ ...d, saved_at: new Date().toISOString() }));
export const getEligDraft = () => { try { return JSON.parse(localStorage.getItem(DRAFT) || "null"); } catch { return null; } };
export const clearEligDraft = () => localStorage.removeItem(DRAFT);
// Document checklist (and uploads) open only once the applicant has submitted their details.
export const DOCS_UNLOCKED = ["details_submitted", "documents_submitted", "in_review", "filed", "biometrics_pending", "biometrics_done", "approved", "refused", "cancelled"];

export async function portalCall(path, body, method = "POST") {
  const r = await apiFetch(`/api/portal${path}`, { method, body: body === undefined ? undefined : JSON.stringify(body) });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(formatApiErrorDetail(data.detail));
  return data;
}
export const portalGet = (path) => portalCall(path, undefined, "GET");

export const createApplicationFromDraft = async (draft) => {
  const body = { destination: draft.destination, category: draft.purpose || "tourist", travel: draft.travel || null, travellers: draft.travellers || 1, source: "eligibility", intent: draft.intent === "tours" ? "tours" : "visa", plan_id: draft.plan_id || null, entry_option: draft.entry_option || null,
    eligibility: draft.score ? { score: draft.score, band: draft.band, answers: draft.answers || [], factors: draft.factors || [], passport: draft.passport, purpose: draft.purpose, raw: draft.raw || {} } : null };
  const app = await portalCall("/applications", body);
  clearEligDraft();
  conversion("apply_start", { destination: body.destination, category: body.category, intent: body.intent, plan: body.plan_id || undefined, travellers: body.travellers });
  return app;
};

export function useApplication(id) {
  const [app, setApp] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(() => { if (!id) return; portalGet(`/applications/${id}`).then(setApp).catch((e) => setError(e.message)); }, [id]);
  useEffect(() => { load(); }, [load]);
  return { app, setApp, reload: load, error };
}

import { money as localMoney } from "./locale";
export const money = (cents, currency = "usd") => (currency || "usd").toLowerCase() === "usd" ? localMoney((cents || 0) / 100) : new Intl.NumberFormat("en-US", { style: "currency", currency: currency.toUpperCase(), maximumFractionDigits: 2 }).format((cents || 0) / 100);
export const fmtDate = (s, opts = { day: "numeric", month: "short", year: "numeric" }) => (s ? new Date(s).toLocaleDateString("en-GB", opts) : ", ");
export const fmtTime = (s) => (s ? new Date(s).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) : "");
export const initials = (u) => ((u?.name || u?.email || "?").trim().split(/\s+/).map((x) => x[0]).join("").slice(0, 2) || "?").toUpperCase();
